import { Box, Button, Grid  } from '@mui/material';
import { IComponentCss, PeriodSelectType } from '@tap/mui-ui';
import { IssuePieChartByAssigneeReportResult } from '@tap/data-providers';
import IssuePieChartByAssigneeTable from './IssuePieChartByAssigneeTable';
import IssuePieChartByAssignee from './IssuePieChartByAssignee';

/* Страница отчета Круговая диаграмма по исполнителям для заявок
*/

// Стили
const css: IComponentCss = {
    contentWrap: {
        position: 'relative',
        display: 'inline-grid',
        width: '100%',
    },
    optionsButton: {
        marginBottom: '5px',
        float: 'right',
    },
    chartWrap: {
        width: '90%',
        marginBottom: '40px',
    },
};

type IssuePieChartByAssigneeReportProps = {
    periodType: PeriodSelectType,
    calculationData: IssuePieChartByAssigneeReportResult[],
    totalIssueCount: number,
    onOptionsButtonClick: () => void,
}


export default function IssuePieChartByAssigneeReport({periodType, calculationData, totalIssueCount, onOptionsButtonClick}: IssuePieChartByAssigneeReportProps) {

    return (
        <>
            <Box sx={css.contentWrap}>
                <Grid>
                    <Button
                        size='small'
                        sx={css.optionsButton}
                        onClick={onOptionsButtonClick}
                    >
                        Параметры отчёта
                    </Button>
                </Grid>
                <Grid sx={css.chartWrap}>
                    <IssuePieChartByAssignee
                        reportData={calculationData}
                        periodType={periodType}
                    />
                </Grid>
                <IssuePieChartByAssigneeTable initialData={calculationData} totalIssueCount={totalIssueCount} />
            </Box>
        </>
    );
}

